import React from 'react';
import { getTimeLeft } from './fleetConstants';

function FleetLaneCard({ lane, isSelected, onSelect }) {
  return (
    <div
      className={`fleet-lane-card ${lane.status === 'FREE' ? 'lane-free' : 'lane-busy'} ${isSelected ? 'lane-selected' : ''}`}
      onClick={(e) => { e.stopPropagation(); onSelect(lane); }}
    >
      <div className={`lane-status-dot ${lane.status === 'FREE' ? 'dot-free' : 'dot-busy'}`} />
      <div className="lane-card-info">
        <span className="lane-card-id">{lane.hardwareId || lane.laneId}</span>
        <span className="lane-card-type">{lane.deviceId?.replace(/^NPEWFM\d+/, '')}</span>
      </div>
      {lane.status === 'IN_USE' && (
        <div className="lane-card-bottom">
          <span className="lane-card-user">{lane.allocatedBy}</span>
          {lane.allocatedAt && <span className="lane-card-timer">{getTimeLeft(lane.allocatedAt, lane.leaseDuration)}</span>}
        </div>
      )}
    </div>
  );
}

export default FleetLaneCard;
